import { ACTION_PANEL_STATE_KEY } from "../../selectors";

export const EVENT_MODULE_STATE_KEY = "EVENT_MODULE_STATE";

export const getModuleState = (state) => state[ACTION_PANEL_STATE_KEY][EVENT_MODULE_STATE_KEY];

export const getTriggeredPage = (state) => getModuleState(state).triggeredPage;
